export default [
  {
    add_promo_code: "Tilføj rabat kode",
    discount: "Rabat",
    invalid_code: "Koden er ikke gyldig.",
    need_validate_promo_code: "Du skal validere koden.",
    offer_text: "Der er  %{amount} rabat hos os.",
    promo_code: "Rabat kode",
    promo_code_description:
      "Hvis du har en rabat kode, indtast den her og få din rabat.",
    we_need_promo_code_valid: "Vi har brug for en gyldig kode",
    NOT_VALID: "Koden er ugyldig",
    CODE_VALID: "Din kode er gyldig",
    ALREADY_USED_CODE: "Du har allerede brugt en anden rabat kode",
    MAX_USE_REACHED: "Koden er allerede brugt",
    REQUIRED_AUTH:
      "Du skal logge ind eller oprette en profil for at bruge denne kode",
  },
];
